var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#C6C6C6",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.962 13.142L.142 2.52a.545.545 0 0 1 1.052-.284l2.82 10.623a.551.551 0 0 1-.385.674.546.546 0 0 1-.667-.39zM11.08 3.814L10.626 2.1 10.103.135a3.218 3.218 0 0 1-1.652.97c-.55.14-1.087.158-1.619.152-.531-.005-1.057-.04-1.587-.045-.532-.006-1.07.012-1.62.151a3.211 3.211 0 0 0-1.651.97c.199.753.367 1.38.521 1.965l.456 1.714.522 1.966a3.208 3.208 0 0 1 1.652-.97c.548-.138 1.086-.158 1.617-.154.532.006 1.058.041 1.589.048.53.007 1.07-.014 1.62-.152a3.226 3.226 0 0 0 1.65-.97l-.52-1.966z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagGray);
export default __webpack_public_path__ + "static/media/flagGray.18274e1cf9517c56c5bf2989f74c2e67.svg";
export { ForwardRef as ReactComponent };